



























import { Vue } from 'vue-property-decorator'
import DocumentTile from '../../components/DocumentTile.vue'

interface IMDResourceFavorite {
  id: number
  name: string
  description: string
  favoriteId: number
  createdDate: string
  resourceLink: string
  imageUrl: string
}

export default Vue.extend({
  data: function () {
    return {
      loading: true,
      mdresourceFavorites: [] as IMDResourceFavorite[],
    }
  },
  mounted: async function () {
    this.mdresourceFavorites = await (
      await fetch(
        '/api/mdresources/favorites?' +
          new URLSearchParams({ isDirectory: 'false' })
      )
    ).json()
    this.mdresourceFavorites = this.mdresourceFavorites.map((x) => ({
      ...x,
      type: 'md-resources',
    }))
    this.loading = false
  },
  methods: {
    removeFavoriteDocument(favoriteId: number) {
      // Trigger the common api removal in the parent element
      this.$emit('remove-favorite', favoriteId)

      this.mdresourceFavorites = this.mdresourceFavorites.filter(
        (mdrf) => mdrf.favoriteId !== favoriteId
      )
    },
  },
  components: {
    DocumentTile,
  },
})
